import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ActivateAutoBillingModalForm } from './form';
import { SimpleModal, Icon } from '@livable/saas-react-components';
export const ActivateAutoBillingModal = observer(_ref => {
  let providerInfo = _ref.providerInfo,
    statementsToPreview = _ref.statementsToPreview,
    companyCredentials = _ref.companyCredentials,
    propertyId = _ref.propertyId,
    customTrigger = _ref.customTrigger,
    urjanetCredentialsForProvider = _ref.urjanetCredentialsForProvider,
    propertyUtility = _ref.propertyUtility,
    callbackTrigger = _ref.callbackTrigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '190-activate-auto-billing-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.activate_auto_billing')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t('add_new_property_flow.activate_auto_billing'),
    subTitle: providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.name,
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger
  }, /*#__PURE__*/React.createElement(ActivateAutoBillingModalForm, {
    providerInfo: providerInfo,
    statementsToPreview: statementsToPreview,
    companyCredentials: companyCredentials,
    propertyId: propertyId,
    urjanetCredentialsForProvider: urjanetCredentialsForProvider,
    propertyUtility: propertyUtility,
    callbackTrigger: callbackTrigger
  }));
});